import { Trans, useTranslation } from 'react-i18next';
import { UserSegmentType } from '~/types/userTypes';

export default function SegmentDetails({
  segment,
  isFinalStep,
}: {
  segment: UserSegmentType | undefined;
  isFinalStep?: boolean;
}) {
  const { t } = useTranslation('app');
  return (
    <div className="flex flex-col gap-x">
      <p className="text-body_2 flex gap-0.5x">
        <Trans
          i18nKey="connectCost"
          t={t}
          values={{
            value: isFinalStep
              ? segment?.leads_bank_proposal_fees?.remaining_amount
              : segment?.leads_bank_proposal_fees?.down_payment_amount,
          }}
          components={{
            tag: <span className="font-bold">placeholder</span>,
          }}
        />
      </p>

      {!isFinalStep && (
        <>
          <p className="text-body_2 flex gap-0.5x">
            <Trans
              i18nKey="totalCost"
              t={t}
              values={{ value: segment?.leads_bank_proposal_fees?.total_cost }}
              components={{
                tag: <span className="font-bold">placeholder</span>,
              }}
            />
          </p>
          <div className="flex w-full gap-x justify-center ">
            <div className="flex w-[8px] h-[8px] bg-orange_light_1 rounded-[50%] mt-0.5x"></div>
            <p className=" text-body_2 text-orange_dark_2 flex-1">
              <Trans
                i18nKey="remainingCostNote"
                t={t}
                values={{
                  value: segment?.leads_bank_proposal_fees?.remaining_amount,
                }}
                components={{
                  tag: <span className="font-bold">placeholder</span>,
                }}
              />
            </p>
          </div>
        </>
      )}
    </div>
  );
}
